import { useEffect, useMemo, useState } from 'react';

import services from 'services';
import { SidebarItem } from 'types';
import { calcAvailableModules, calcRoutedModules, isAppModule } from 'utils';

const getSidebarItems = () => calcAvailableModules(services.appFrame.sidebar.getItems()).filter(isAppModule);

export interface NavigationResult {
  routedModules: SidebarItem[];
  appModules: SidebarItem[];
  defaultModule: SidebarItem | null;
}

const useSidebarNavigation = () => {
  const [sidebarItems, setSidebarItems] = useState<SidebarItem[]>(getSidebarItems);
  useEffect(() => {
    services.appFrame.sidebar.onItemChange(() => {
      setSidebarItems(getSidebarItems());
    });
  }, []);

  return useMemo(() => {
    const routedModules = calcRoutedModules(sidebarItems);

    const result: NavigationResult = {
      routedModules,
      defaultModule: sidebarItems.find((module) => isAppModule(module) && module.default) || routedModules[0] || null,
      appModules: sidebarItems.filter((module) => !module.hidden),
    };

    return result;
  }, [sidebarItems]);
};

export default useSidebarNavigation;
